import { render, staticRenderFns } from "./PrivateOrderColumn.vue?vue&type=template&id=429df192&"
import script from "./PrivateOrderColumn.vue?vue&type=script&lang=js&"
export * from "./PrivateOrderColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports